import { render, staticRenderFns } from "./AttractionManage.vue?vue&type=template&id=a3ebc084&scoped=true"
import script from "./AttractionManage.vue?vue&type=script&lang=js"
export * from "./AttractionManage.vue?vue&type=script&lang=js"
import style0 from "./AttractionManage.vue?vue&type=style&index=0&id=a3ebc084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ebc084",
  null
  
)

export default component.exports